import React from 'react';
import PropTypes from 'prop-types';
const sortBy = require('lodash/sortBy');
const uuid = require('uuid');

const ProjectStore = require('../../stores/ProjectStore');
const CollaboratorActions = require('../../actions/CollaboratorActions');
const CollaboratorStore = require('../../stores/CollaboratorStore');
const OrganizationMemberStore = require('../../stores/OrganizationMemberStore');
const OrganizationActions = require('../../actions/OrganizationActions');
import LoadingMainContent from '../loading/LoadingMainContent';
import AccessibleIcon from '../common/AccessibleIcon';
import OrgProjectPermissionsTile from './OrgProjectPermissionsTile';

const propTypes = {
    orgId: PropTypes.number.isRequired,
    userPermissions: PropTypes.object,
    backHandler: PropTypes.func
};

const defaultProps = {
    userPermissions: {},
    backHandler: null
};

class OrgProjectPermissionsView extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            getOrgMembersActionId: null,
            organizationMemberStoreState: OrganizationMemberStore.getState(),
            projectStoreState: ProjectStore.getState(),
        };

        this.unsubscribes = [
            ProjectStore.listen(this.onStoreChange.bind(this, "projectStoreState")),
            OrganizationMemberStore.listen(this.onOrganizationMemberStoreChange.bind(this)),
        ];
    }

    componentDidMount() {
        // re-fetch these on each mounting
        CollaboratorActions.getChannelProjectsCollabs(uuid.v4(), { channelId: this.props.orgId });

        const getOrgMembersActionId = uuid.v4();
        this.setState({ getOrgMembersActionId: getOrgMembersActionId }, () => {
            OrganizationActions.getMembers(uuid.v4(), { id: this.props.orgId });
        });
    }

    componentWillUnmount() {
        this.unsubscribes.forEach(u => u());
    }

    onStoreChange(storeStateName, state) {
        this.setState({ [storeStateName]: state })
    }

    onOrganizationMemberStoreChange(state) {
        let additionalState = {};
        if (state.action.id === this.state.getOrgMembersActionId) {
            additionalState = { ...additionalState, getOrgMembersActionId: null };
        }

        this.setState({ organizationMemberStoreState: state, ...additionalState });
    }

    render() {
        if (
            !this.state.projectStoreState.initialized
            || !this.state.organizationMemberStoreState.members[this.props.orgId]
        ) {
            return <LoadingMainContent />;
        }

        const channelProjects = this.state.projectStoreState.projects.filter(project => project.channelId === this.props.orgId);
        const sortedProjects = sortBy(channelProjects, project => project.name.toLowerCase());
        const orgMembers = this.state.organizationMemberStoreState.members[this.props.orgId];
        return (
            <div>
                <div className="channelHeadingFlex">
                    <div className="channelHeadingFlex__heading">
                        { !!this.props.backHandler &&
                                <button
                                className="btn btn-primary glyph btn-circle btn-lg margin-right-15"
                                onClick={this.props.backHandler}
                                title="Back">
                                    <AccessibleIcon label="Back">
                                        <span className="fa fa-chevron-left" aria-hidden="true"/>
                                    </AccessibleIcon>
                                </button>
                        }
                        <h2 className="heading-lg">{this.props.heading}</h2>
                    </div>
                </div>

                {sortedProjects.map((project) => 
                    <OrgProjectPermissionsTile
                        key={project.id}
                        projectId={project.id}
                        orgMembers={orgMembers}
                    />
                )}
                {(sortedProjects.length === 0) &&
                    <div className="font-style-italic font-weight-bold text-centered margin-bottom-lg">
                        No projects
                    </div>
                }
            </div>
        )
    }
}

OrgProjectPermissionsView.propTypes = propTypes;
OrgProjectPermissionsView.defaultProps = defaultProps;

export default OrgProjectPermissionsView;